import * as React from "react";
import MonacoEditor from 'react-monaco-editor';
import { apiQuery, deleteCommand, findOneCommand, updateCommand, queueQuery, bulkManipulate } from '../templates';
import async from 'async';
import swal from 'sweetalert2';
import { CaretRightOutlined, FormatPainterOutlined, CodeSandboxOutlined, ClearOutlined } from '@ant-design/icons';
import { Menu, Layout, theme, Tooltip, Switch, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import http from '../interceptors/httpInterceptor';
const { Header, Content, Sider } = Layout;

const MonacoEditorComponent = React.forwardRef((props, ref) => {
  const brokerStatus = useSelector(state => state.brokerStatus); // Access the shared state
  const brokerLogs = useSelector(state => state.brokerLogs);
  const [output, setOutput] = React.useState([]);
  const dispatch = useDispatch();
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [code, setCode] = React.useState(props.input.lastScript);
  const [logStyle, setLogStyle] = React.useState(false);
  const [options, setOptions] = React.useState({
    selectOnLineNumbers: true
  })
  const editorDidMount = (editor, monaco) => {
    console.log('editorDidMount', editor);
    editor.focus();
  }
  const onChange = (newValue, e) => {
    // console.log('onChange', newValue, e);
    setCode(newValue);
  }

  const toggleLogStyle = (newValue, e) => {
    console.log('onChange', newValue, e);
    setLogStyle(newValue);
  }

  const [current, setCurrent] = React.useState('mail');
  const onClick = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
    if (e.key === 'run') {
      execute();
    }
    if (e.key === 'clear') {
      setOutput([]);
      // document.getElementById('text-display').innerHTML = '';
    }
  };

  const execute = () => {
    swal({
      title: "Are you sure?",
      text: "You gotta do what you gotta do",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, run it!",
      cancelButtonText: "Abort plz!"
    }).then((result) => {
      if (result.value) {

        http.post("/o/script_console.bto", {
          script: code
        }).then((response) => {
          console.log(response);
          if (response.data.success) {
            localStorage.setItem("ob.lastscript", JSON.stringify({
              value: code
            }));
            $.notify({
              title: '<strong>Success!</strong>',
              message: 'Script Executed.'
            }, {
              placement: {
                from: "bottom",
                align: "right"
              },
              allow_dismiss: false,
              type: 'minimalist',
              delay: 4000,
              icon_type: 'image',
              template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                '<img data-notify="icon" class="img-circle pull-left">' +
                '<span data-notify="title">{1}</span>' +
                '<span data-notify="message">{2}</span>' +
                '</div>'
            });
          }
        });
      } else {
        swal("Cancelled", "Execution aborted!", "error");
      }

    });
  }

  const items = [
    {
      label: '',
      key: 'run',
      icon: <Tooltip placement="top" title="Execute a script"><CaretRightOutlined style={{ fontSize: '20px' }} /></Tooltip>,
    },
    {
      label: '',
      key: 'templates',
      icon: <CodeSandboxOutlined style={{ fontSize: '20px' }} />,
      children: [
        {
          type: 'group',
          label: 'Code Templates',
          children: [
            {
              label: 'API Query',
              key: 'apiQuery',
            },
            {
              label: 'Delete Script',
              key: 'deleteCommand',
            },
          ],
        }
      ],
    },
    {
      label: '',
      key: 'clear',
      icon: <Tooltip placement="top" title="Clear output console"><ClearOutlined style={{ fontSize: '20px' }} /></Tooltip>
    },
    {
      label: '',
      key: 'toggle',
      icon: <Space direction="horizontal"><Switch checkedChildren="Chat" unCheckedChildren="Log" onChange={toggleLogStyle} defaultValue={false} /></Space>
    }
  ];

  React.useEffect(() => {
    // Make an HTTP request using the angularHttpService
    // http.get('/o/recs/pltf_navigation_app?oquery=active=true,mobile=false&stream=true&project=title,image,name,order,_id,domain,role')
    //   .then(response => {
    //     // Handle the response data
    //     console.log('Response data:', response.data);
    //   })
    //   .catch(error => {
    //     // Handle errors
    //     console.error('Error:', error);
    //   });
  }, []);

  // Memoize the component rendering
  const memoizedComponent = React.useMemo(() => {
    // Render your component here
    // return <div><p>Counter Value: {counter}</p></div>;
    // setCode(counter.toString());
    //Subscribe to broker
    console.log(brokerStatus);
  }, [brokerStatus]);
  let cursorPosition = 0;

  React.useMemo(() => {
    //Subscribe to broker
    if (!brokerLogs) {
      return;
    }
    if (!logStyle) {
      setOutput([...output, ...[`${brokerLogs.time} - ${brokerLogs?.message}`]]);
    } else {
      const characters = brokerLogs.message ? brokerLogs?.messagesg.replace(/[",\\]/g, '') : '';
      document.getElementById('text-display').innerHTML += `${characters}`;
    }
  }, [brokerLogs]);

  return (
    <React.Fragment>
      <Layout>
        <Header
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
          }}
        >
          <Menu style={{ width: '100%' }} theme="dark" onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />
        </Header>
        <Layout>
          <Sider
            width="50%"
            style={{
              background: 'black',
              minWidth: '50%',
              maxWidth: '50%'
            }}
          >
            <MonacoEditor
              language="javascript"
              width="100%"
              height="635px"
              theme="vs-dark"
              value={code}
              options={options}
              onChange={onChange}
              editorDidMount={editorDidMount}
            />
          </Sider>
          <Content
            style={{
              padding: 24,
              margin: 0,
              minHeight: 280,
              maxHeight: '635px',
              overflow: 'scroll',
              color: 'lightgreen',
              maxWidth: '50%',
              background: 'black',
            }}
          >
            {!logStyle && output.map(log => <p style={{
              'marginTop': 0,
              'marginBottom': 0,
              'fontSize': 'smaller',
              'fontFamily': 'monospace'
            }} key={log}>{log}</p>)}

            {logStyle && <div id="text-display"></div>}
          </Content>
        </Layout>
      </Layout>
    </React.Fragment>
  );
})

export default MonacoEditorComponent;